import { Component, OnInit, Inject } from '@angular/core';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { FormBuilder } from '@angular/forms';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';

@Component({
  selector: 'app-movetoForm',
  templateUrl: './movetoForm.component.html',
  styleUrls: ['./movetoForm.component.scss'] 
})

export class MovetoFormComponent implements OnInit {
  
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
 
  OfficeIDList: any=[];
  myOfficeID: any;
  
  FormidItemTobeMoved:number;
  parentIdTobeMoved:number;
  newParentFolderSelected: number=0;
  spinner:boolean=false;
  FormFolderList:any=[]=[];
  activeNode: string = "";
  hierarchyList:any=[]=[];
  breadCrumMenu:any=[]=[];
  selectButtonMyFormShow:boolean=false;
  menuHeaderMyForm: any = []=[];
  isForm:boolean=false;

  private _transformer = (node: FoodNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      formFolderName: node.formFolderName,
      formFolderID:node.formFolderID,
      parentID:node.parentID,
      level: level,
      isShared:node.isShared
    };
  }
  
  treeControl = new FlatTreeControl<ExampleFlatNode>(node => node.level, node => node.expandable); 
  treeFlattener = new MatTreeFlattener(this._transformer, node => node.level, node => node.expandable, node => node.children);
  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  
  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

  constructor( private _dataSharingService: DataSharingService,private dialog: MatDialog,
    public dialogRef: MatDialogRef<MovetoFormComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses,private settingsService: SettingService,
    private statusConst: StatusConstant,private toastr: ToastrService) {   
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);   
    this.currentUser = jwt_decode(token); 
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID)	
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });	   
    this.isForm = data.isForm;
    this.FormidItemTobeMoved = data.Formid;
    this.parentIdTobeMoved = data.parentId;
  }  
  
  ngOnInit(): void {
    this.getFormFolderList();
  }
   
  getFormFolderList() {
    var ReqModel = {
      formFolderID: 0,
      formFolderName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID:this.myOfficeID,
      databaseID: Number(this.databaseId),
    }
    this.settingsService.getFormFolderList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;       
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {         
          this.FormFolderList = this.responseHolder.data;
          if (this.FormFolderList.length > 0) {
            this.dataSource.data = this.FormFolderList;//this.FormFolderList.filter(m=>m.formFolderID!=this.parentIdTobeMoved);
            this.selectButtonMyFormShow = true;
          }
          this.selectButtonMyFormShow = true;
        }
        else {
          this.selectButtonMyFormShow = true;
        }
      }
      else {
      }
    });  
  }

  getFormFolderWithFormTemplates(form) {
    this.newParentFolderSelected =Number(form.formFolderID);
    this.activeNode=form.formFolderID;

    var ReqModel = {
      formFolderID:form.formFolderID,
      formFolderName:"",
      userID:this.currentUser.UID,
      organizationID:Number(this.organizationId),
      OfficeID:this.myOfficeID,
      databaseID:Number(this.databaseId)     
    }
    this.settingsService.GetParentFormFolderHierarchy(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;       
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {         
          this.hierarchyList = response.data.hierarchy;
          this.menuHeaderMyForm=[];
          if(this.hierarchyList != null || this.hierarchyList != undefined){         
            this.hierarchyList.forEach(e => {
              this.menuHeaderMyForm.push({ label: e.formFolderName,id:e.formFolderID,icon: 'navigate_next' });
            });
          }
        }
        else {
        }
      }
      else {
      }
    });
  }

 
  onFolderSelectToMove(){
    //return;
    let ReqModel = {
      newFormFolderID: this.newParentFolderSelected,
      formID: this.FormidItemTobeMoved,
      userID: this.currentUser.UID,
      organizationID: this.organizationId,
      databaseID: this.databaseId,
      officeID: this.myOfficeID,
      isForm: this.isForm
    }
    this.spinner=true;
    this.selectButtonMyFormShow=false;
    this.settingsService.MoveForm(ReqModel).subscribe((response)=>{
      if(response.data == true){
        this.spinner=false;
         this.toastr.success('Record moved successfully.', '', {
          timeOut: 3000,
         });
         var obj={
          newParentFolderSelected:this.newParentFolderSelected,
          menuHeaderMyForm:this.menuHeaderMyForm
         }
       // this._dataSharingService.sendSelectedParentFormIDForMove(this.newParentFolderSelected);
        this.dialogRef.close(obj);
      }else{
        this.spinner=false;
        this.selectButtonMyFormShow=false;
      }
    })
  }
   
 breadCrumbMyFormMainClick(){
    this.FormFolderList=[];
    this.menuHeaderMyForm=[];
    this.activeNode="";
    this.getFormFolderList();
    this.selectButtonMyFormShow=true;
  }

  breadCrumbMyForm(menu,index){
    this.selectButtonMyFormShow=true;
    this.menuHeaderMyForm.splice(index + 1, this.menuHeaderMyForm.length - 1);
    if (menu[index] && menu[index].items && menu[index].items.length) {
      this.FormFolderList = menu[index].items;
    }
    var data = this.menuHeaderMyForm[index];
    if(data!=null && data!=undefined){
      var obj={
        formFolderID:data.id
      }
      this.getFormFolderWithFormTemplates(obj);  
    }
  }

  close() {
     // For My Form // 
     this.menuHeaderMyForm=[];
     this.FormFolderList=[];
     this.activeNode="";
     this.selectButtonMyFormShow=false;
     this.dialog.closeAll();
  } 
  
}

/** Flat node with expandable and level information */
interface FoodNode {
  formFolderName: string;
  children?: FoodNode[];
  formFolderID:number;
  parentID:number;
  isShared:boolean;
}


/** Flat node with expandable and level information */
interface ExampleFlatNode {
  expandable: boolean;
  formFolderName: string;
  level: number;
  formFolderID:number;
  parentID:number;
  isShared:boolean;
}


